<template>
  <div class="content-page">
    <div class="container">
      <h1 class="page-title">{{ title }}</h1>
      <div class="loading-container" v-if="loading">
        <div class="loading-spinner"></div>
        <p>加载中...</p>
      </div>
      <div class="error-message" v-else-if="error">
        <p>{{ error }}</p>
        <button @click="fetchContent" class="retry-btn">重试</button>
      </div>
      <div class="content-container" v-else>
        <div class="content-image" v-if="content.image_url">
          <img :src="content.image_url" :alt="content.title">
        </div>
        <div class="content-html" v-html="content.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAboutContent } from '../api/index';

const DEFAULT_CONTENT = {
  agreement: {
    title: '用户协议',
    content: `
      <h2>一、总则</h2>
      <p>欢迎您使用格瑞创新动漫平台（以下简称"本平台"）。本平台由北京格瑞创新科技有限公司运营。请您在使用本平台前仔细阅读本协议，一旦您注册、登录或以任何方式使用本平台，即表示您已阅读并同意本协议的全部条款。</p>

      <h2>二、服务内容</h2>
      <p>1. 本平台为用户提供漫画阅读、漫画创作投稿、会员服务、金币充值等功能。</p>
      <p>2. 本平台有权根据业务发展需要调整服务内容，并将在平台上进行公示。</p>

      <h2>三、用户注册与账号</h2>
      <p>1. 用户须使用真实手机号注册账号，并对账号及密码的安全负责。</p>
      <p>2. 用户不得将账号转让、出借给他人使用，因账号保管不当造成的损失由用户自行承担。</p>
      <p>3. 用户年龄不满18周岁的，应在监护人陪同下使用本平台，并建议开启青少年保护模式。</p>

      <h2>四、用户行为规范</h2>
      <p>用户在使用本平台时，应遵守以下规范：</p>
      <p>1. 不得发布、传播违法、淫秽、暴力、歧视等不良信息；</p>
      <p>2. 不得侵犯他人知识产权、隐私权等合法权益；</p>
      <p>3. 不得利用本平台从事任何危害网络安全的行为；</p>
      <p>4. 不得以任何方式干扰本平台的正常运行。</p>

      <h2>五、知识产权</h2>
      <p>1. 本平台上的所有漫画作品、文章、图片、音视频等内容，其知识产权归原作者或本平台所有，未经授权不得转载、复制或用于其他商业用途。</p>
      <p>2. 用户在本平台投稿的原创作品，知识产权归用户所有，但用户授权本平台在平台范围内展示和推广。</p>

      <h2>六、付费服务</h2>
      <p>1. 本平台提供VIP会员服务和金币充值服务，用户可自愿购买。</p>
      <p>2. 虚拟商品一经购买，除法律另有规定外，不予退款。</p>
      <p>3. 开启青少年保护模式后，付费功能将受到限制。</p>

      <h2>七、免责声明</h2>
      <p>1. 本平台不对用户发布内容的真实性、合法性负责。</p>
      <p>2. 因不可抗力、系统维护等原因导致服务中断，本平台不承担责任。</p>
      <p>3. 本平台不对因用户自身原因（如账号泄露）造成的损失负责。</p>

      <h2>八、协议变更</h2>
      <p>本平台有权根据法律法规及业务需要修改本协议，修改后的协议将在平台上公布，自公布之日起生效。如用户不同意修改内容，可停止使用本平台。</p>

      <h2>九、法律适用与争议解决</h2>
      <p>本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。因本协议引起的争议，双方应协商解决，协商不成的，可向本平台所在地有管辖权的人民法院提起诉讼。</p>

      <p style="margin-top:30px;color:#1a2f4a;opacity:0.7;">最后更新日期：2026年1月1日</p>
    `
  },
  privacy: {
    title: '隐私政策',
    content: `
      <h2>一、引言</h2>
      <p>北京格瑞创新科技有限公司（以下简称"我们"）非常重视用户隐私保护。本隐私政策旨在说明我们如何收集、使用、存储和保护您的个人信息。请您在使用格瑞创新动漫平台前仔细阅读本政策。</p>

      <h2>二、我们收集的信息</h2>
      <p>1. <strong>注册信息</strong>：手机号码，用于账号注册和登录。</p>
      <p>2. <strong>使用信息</strong>：您的阅读记录、收藏、购买记录、使用时长等。</p>
      <p>3. <strong>设备信息</strong>：设备型号、操作系统版本、IP地址等，用于安全保障和性能优化。</p>
      <p>4. <strong>投稿信息</strong>：您主动提交的漫画作品及相关描述信息。</p>

      <h2>三、信息使用</h2>
      <p>我们收集的信息将用于：</p>
      <p>1. 提供漫画阅读、会员服务、金币充值等核心功能；</p>
      <p>2. 个性化推荐和内容展示；</p>
      <p>3. 青少年保护模式的时长统计与访问控制；</p>
      <p>4. 安全防护、反欺诈及风险控制；</p>
      <p>5. 遵守法律法规的要求。</p>

      <h2>四、信息存储与保护</h2>
      <p>1. 您的个人信息存储在位于中华人民共和国境内的服务器上。</p>
      <p>2. 我们采用加密传输、访问控制、安全审计等技术手段保护您的信息安全。</p>
      <p>3. 密码等敏感信息使用bcrypt算法进行哈希存储，不以明文形式保存。</p>
      <p>4. 仅授权人员在必要范围内可访问您的个人信息，并受严格保密义务约束。</p>

      <h2>五、信息共享与披露</h2>
      <p>1. 我们不会向第三方出售您的个人信息。</p>
      <p>2. 在以下情形下，我们可能披露您的信息：经您同意；法律法规要求；司法机关或行政机关依法要求；为保护本平台及用户的合法权益。</p>

      <h2>六、青少年保护</h2>
      <p>1. 我们高度重视青少年保护，提供青少年保护模式功能，包括使用时长限制、夜间宵禁和消费限制。</p>
      <p>2. 对于不满14周岁的未成年人，我们将在监护人同意的前提下处理其个人信息。</p>
      <p>3. 青少年保护模式下的使用时长数据仅用于时限管理，不会用于其他用途。</p>

      <h2>七、Cookie与同类技术</h2>
      <p>我们使用localStorage等技术保存您的登录状态和阅读进度，以提升使用体验。您可通过浏览器设置清除这些数据。</p>

      <h2>八、您的权利</h2>
      <p>1. 您有权访问、更正、删除您的个人信息。</p>
      <p>2. 您有权注销账号，注销后我们将删除您的个人信息。</p>
      <p>3. 如需行使上述权利，请致电客服电话：13810795803。</p>

      <h2>九、政策变更</h2>
      <p>我们可能适时修订本隐私政策，更新后将在平台上公示。重大变更将通过站内通知或短信告知您。</p>

      <h2>十、联系我们</h2>
      <p>如您对本隐私政策有任何疑问，可通过以下方式联系我们：</p>
      <p>电话：13810795803</p>
      <p>地址：北京市朝阳区北辰东路8号院16号楼4层A406</p>

      <p style="margin-top:30px;color:#1a2f4a;opacity:0.7;">最后更新日期：2026年1月1日</p>
    `
  },
  contact: {
    title: '联系我们',
    content: `
      <h2>客服支持</h2>
      <p>如您在使用格瑞创新动漫平台过程中遇到任何问题，或对我们的服务有任何建议，欢迎随时与我们联系。</p>

      <h2>联系方式</h2>
      <p><strong>客服电话</strong>：13810795803</p>
      <p><strong>公司地址</strong>：北京市朝阳区北辰东路8号院16号楼4层A406</p>
      <p><strong>官方网站</strong>：www.comicshort.cn</p>

      <h2>服务时间</h2>
      <p>工作日 9:00 - 18:00，节假日可能有所调整，请您谅解。</p>

      <h2>反馈建议</h2>
      <p>我们非常重视您的意见。如果您发现平台内容存在侵权、违规或其他问题，也请及时与我们联系，我们将尽快核实并处理。</p>

      <p style="margin-top:30px;color:#1a2f4a;opacity:0.7;">最后更新日期：2026年1月1日</p>
    `
  }
};

export default {
  name: 'ContentPage',
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['about', 'contact', 'agreement', 'privacy'].includes(value)
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      content: {},
      loading: true,
      error: null
    }
  },
  created() {
    this.fetchContent();
  },
  methods: {
    // 规范化后端富文本：把字面 \r\n / \n / \r 换成 <br>，
    // 避免 v-html 直接渲染时显示成 \r\n 字符串。
    normalizeContent(raw) {
      if (!raw) return '';
      return String(raw)
        .replace(/\\r\\n/g, '<br>')
        .replace(/\\n/g, '<br>')
        .replace(/\\r/g, '<br>')
        .replace(/\r\n/g, '<br>')
        .replace(/\n/g, '<br>')
        .replace(/\r/g, '<br>');
    },
    async fetchContent() {
      this.loading = true;
      this.error = null;

      try {
        console.log(`[ContentPage] 获取${this.title}内容，类型:`, this.type);
        const res = await getAboutContent(this.type);

        const data = (res.data && res.data.code === 1) ? res.data.data : null;
        // 判断后端内容是否有效：有实际的 content 字段且不是占位文字
        const hasRealContent = data && data.content
          && data.content.trim().length > 20
          && !data.content.includes('请在后台编辑');

        if (hasRealContent) {
          this.content = { ...data, content: this.normalizeContent(data.content) };
          console.log(`[ContentPage] ${this.title}内容获取成功:`, this.content.title);
        } else if (DEFAULT_CONTENT[this.type]) {
          // 后端无数据或为占位文字，使用默认内容兜底
          this.content = { ...DEFAULT_CONTENT[this.type] };
          console.log(`[ContentPage] ${this.title}使用默认内容`);
        } else {
          this.error = res.data.msg || '获取内容失败';
        }
      } catch (e) {
        // 网络错误时也尝试使用默认内容
        if (DEFAULT_CONTENT[this.type]) {
          this.content = { ...DEFAULT_CONTENT[this.type] };
          console.log(`[ContentPage] ${this.title}网络错误，使用默认内容`);
        } else {
          this.error = '网络错误，请稍后重试';
        }
        console.error(`[ContentPage] ${this.title}内容获取出错:`, e);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.content-page {
  padding: 48px 20px 64px;
  min-height: calc(100vh - var(--nav-h));
  background: var(--bg);
  position: relative;
  overflow: hidden;
}

.container {
  position: relative;
  z-index: 1;
  max-width: 860px;
  margin: 0 auto;
  padding: 0;
}

.page-title {
  text-align: center;
  margin-bottom: 36px;
  color: var(--text);
  font-size: clamp(28px, 4vw, 38px);
  font-weight: 800;
  letter-spacing: -0.02em;
  background: linear-gradient(135deg, #ffffff 0%, #bfecff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--surface-3);
  border-top: 4px solid var(--brand);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  text-align: center;
  padding: 30px;
  color: var(--danger);
}

.retry-btn {
  background: var(--brand);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 15px;
}

.retry-btn:hover {
  background: var(--brand-hover);
}

.content-container {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--radius-lg);
  padding: 32px;
  color: var(--text);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  transition: transform .25s ease, border-color .25s ease, background .25s ease;
}

.content-container:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.11);
}

.content-image {
  margin-bottom: 20px;
}

.content-image img {
  max-width: 100%;
  border-radius: var(--radius-sm);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.content-html {
  line-height: 1.85;
  color: var(--text-dim);
  font-size: 15px;
}

.content-html :deep(h2) {
  margin: 28px 0 14px;
  font-size: 22px;
  color: var(--text);
  border-left: 4px solid var(--brand);
  padding-left: 12px;
  font-weight: 700;
}

.content-html :deep(p) {
  margin: 12px 0;
  color: var(--text-dim);
}

.content-html :deep(ul),
.content-html :deep(ol) {
  margin: 14px 0;
  padding-left: 24px;
}

.content-html :deep(li) {
  margin: 8px 0;
  color: var(--text-dim);
}

.content-html :deep(strong) {
  color: var(--text);
  font-weight: 600;
}

.content-html :deep(a) {
  color: #7dd3fc;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px solid transparent;
  transition: border-color .2s ease;
}

.content-html :deep(a:hover) {
  border-color: #7dd3fc;
}

.content-html :deep(p[style*="margin-top:30px"]) {
  color: var(--text-faint) !important;
  opacity: 1 !important;
}
</style> 